// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation, Outlet, useSearchParams } from "react-router-dom";
// import { Header } from "../../../components/Header/Header";
// import { Search } from "lucide-react";
// import Cookies from "js-cookie";
// import { toast } from "react-toastify";
// import api from "../../chat/api";
// import DynamicColumnDropdown from "./DynamicColumnDropdown";

// export const ColumnIcon = ({ className }) => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
//     <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
//     <line x1="12" y1="3" x2="12" y2="21"></line>
//   </svg>
// );

// const VIEWS_CONFIG = {
//   RESPONSE_EVAL: {
//     apiView: "response_evaluation",
//     storageKey: "analytics_columnPreferences_v1",
//     primaryColumn: "timestamp",
//     labels: {
//       timestamp: "Date & Time",
//       context: "Context",
//       user_query: "User Query",
//       feedback: "Feedback",
//       feedback_comment: "Comment",
//       member: "User",
//       response: "AI Response",
//     },
//     defaults: [
//       { name: "timestamp", visible: true, order: 0 },
//       { name: "feedback", visible: true, order: 1 },
//       { name: "user_query", visible: true, order: 2 },
//       { name: "response", visible: true, order: 3 },
//       { name: "context", visible: true, order: 4 },
//       { name: "member", visible: true, order: 5 },
//       { name: "feedback_comment", visible: true, order: 6 },
//     ]
//   },
//   KNOWLEDGE_GAPS: {
//     apiView: "knowledge_gap",
//     storageKey: "knowledgeGaps_columnPreferences_v2", 
//     primaryColumn: "timestamp", 
//     labels: {
//       timestamp: "Date & Time",
//       user_query: "User Query",
//       context: "Context",
//       response: "AI Response",
//       chat_score: "Chat Score"
//     },
//     defaults: [
//       { name: "timestamp", visible: true, order: 0 },
//       { name: "user_query", visible: true, order: 1 },
//       { name: "context", visible: true, order: 2 },
//       { name: "response", visible: true, order: 3 },
//       { name: "chat_score", visible: true, order: 4 },
//     ]
//   }
// };

// const AnalyticsLayout = ({ isMenuOpen }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const currentPath = location.pathname.toLowerCase();

//   const [searchParams, setSearchParams] = useSearchParams();
//   // Get owner organization ID directly from cookies
//   const orgId = Cookies.get("selected_org_id");

//   const [searchQuery, setSearchQuery] = useState("");
//   const [isColumnDropdownOpen, setIsColumnDropdownOpen] = useState(false);

//   const isKnowledgeGaps = currentPath.includes("knowledge-gaps");
//   const searchPlaceholder = isKnowledgeGaps ? "Search queries..." : "Search queries or feedback...";
//   const activeConfig = isKnowledgeGaps ? VIEWS_CONFIG.KNOWLEDGE_GAPS : VIEWS_CONFIG.RESPONSE_EVAL;

//   const [columnPreferences, setColumnPreferences] = useState([]);
//   const [isLoadingColumns, setIsLoadingColumns] = useState(true); 

//   // Reset Search Query and Dropdown on Route change
//   useEffect(() => {
//     setSearchQuery("");
//     setIsColumnDropdownOpen(false);
//   }, [currentPath]);

//   // Automatically enforce the selected_org_id into the URL parameters
//   useEffect(() => {
//     if (orgId && searchParams.get("org_id") !== orgId) {
//       const params = new URLSearchParams(searchParams);
//       params.set("org_id", orgId);
//       setSearchParams(params, { replace: true });
//     }
//   }, [orgId, searchParams, setSearchParams]);

//   useEffect(() => {
//     const fetchColumns = async () => {
//       setIsLoadingColumns(true);
//       try {
//         const saved = localStorage.getItem(activeConfig.storageKey);
//         if (saved) setColumnPreferences(JSON.parse(saved));
//         else setColumnPreferences(activeConfig.defaults);

//         const token = Cookies.get("access_token");
//         if (!token) return;

//         const response = await api.get(`/api/v1/rfp/column-preferences/?view=${activeConfig.apiView}`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
        
//         if (response.data && response.data.columns) {
//           setColumnPreferences(response.data.columns);
//           localStorage.setItem(activeConfig.storageKey, JSON.stringify(response.data.columns));
//         }
//       } catch (error) {
//         console.error(`Failed to fetch column preferences for ${activeConfig.apiView}:`, error);
//       } finally {
//         setIsLoadingColumns(false); 
//       }
//     };
//     fetchColumns();
//   }, [activeConfig.apiView, activeConfig.storageKey, activeConfig.defaults]);

//   const saveColumnPreferences = async (updatedColumns) => {
//     try {
//       const payload = {
//         view: activeConfig.apiView,
//         columns: updatedColumns.map((col, index) => ({
//           name: col.name,
//           visible: col.visible === true || col.visible === "true",
//           order: index,
//         })),
//       };
//       setColumnPreferences(payload.columns);
//       localStorage.setItem(activeConfig.storageKey, JSON.stringify(payload.columns));
//       const token = Cookies.get("access_token");
//       await api.patch("/api/v1/rfp/column-preferences/", payload, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//     } catch (error) {
//       console.error("Failed to save column preferences:", error);
//     }
//   };

//   const tabs = [
//     { name: "Response Evaluation", path: "response-evaluation" },
//     { name: "Knowledge Gaps", path: "knowledge-gaps" },
//   ];

//   return (
//     <div className="flex flex-col h-full w-full font-outfit overflow-hidden bg-[#FAFAFA] relative">
//       <div className="flex-shrink-0 bg-white">
//         <Header name="Analytics" icon={""} isMenuOpen={isMenuOpen} />
//       </div>

//       <div className="flex justify-between items-center px-6 pt-2 pb-0 bg-white flex-shrink-0 w-full">
//         <div className="flex items-center gap-4 border-b-[1px]">
//           {tabs.map((tab) => {
//             const isActive = currentPath.includes(tab.path.toLowerCase()) || (currentPath.endsWith('/analytics') && tab.path === 'response-evaluation');
//             return (
//               <button
//                 key={tab.name}
//                 onClick={() => navigate(`${tab.path}?${searchParams.toString()}`)}
//                 className={`font-outfit text-[15px] pb-0 px-1 transition-colors ${
//                   isActive ? "text-[#BB42AE] font-semibold border-b-[2px] border-[#BB42AE]" : "text-[#707070] font-medium border-transparent hover:text-[#C95EBE]"
//                 }`}
//               >
//                 {tab.name}
//               </button>
//             );
//           })}
//         </div>

//         <div className="flex items-center gap-3 pb-3">
//           <div id="analytics-filter-portal" className="empty:hidden"></div>
//           <div className="relative inline-flex items-center gap-2">
//             <button
//               onClick={() => setIsColumnDropdownOpen((p) => !p)}
//               disabled={isLoadingColumns}
//               className={`flex items-center gap-2 px-3 py-1.5 border rounded text-[14px] font-outfit transition-colors ${
//                 isLoadingColumns ? "opacity-50 cursor-not-allowed border-[#00000036] text-[#52525B]" :
//                 isColumnDropdownOpen ? "border-[#BB42AE] text-[#BB42AE] bg-[#F8F3FF]" : "border-[#00000036] text-[#52525B] hover:bg-gray-50"
//               }`}
//             >
//               {isLoadingColumns ? (
//                 <div className="w-3.5 h-3.5 border-2 border-[#52525B] border-t-transparent rounded-full animate-spin"></div>
//               ) : (
//                 <ColumnIcon />
//               )}
//               Columns
//             </button>
//             {isColumnDropdownOpen && !isLoadingColumns && (
//               <>
//                 <div className="fixed inset-0 z-[998] bg-transparent" onClick={() => setIsColumnDropdownOpen(false)} />
//                 <DynamicColumnDropdown
//                   columns={columnPreferences}
//                   setColumns={setColumnPreferences}
//                   onSave={saveColumnPreferences}
//                   onClose={() => setIsColumnDropdownOpen(false)}
//                   primaryColumn={activeConfig.primaryColumn}
//                   columnLabels={activeConfig.labels}
//                   defaultColumns={activeConfig.defaults}
//                   storageKey={activeConfig.storageKey}
//                 />
//               </>
//             )}
//           </div>
//           <div className="relative w-[250px]">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600" size={18} />
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="w-full pl-10 pr-4 border rounded-md box-border h-[35px] text-[14px]"
//             />
//           </div>
//         </div>
//       </div>

//       <div className="flex-1 flex flex-col overflow-hidden bg-[#fafafa]">
//         <Outlet context={{ searchQuery, orgId, columnPreferences, isLoadingColumns }} />
//       </div>

//       <div id="analytics-footer-portal" className="w-full bg-white border-t border-black/10 flex-shrink-0 z-10 empty:hidden"></div>
//     </div>
//   );
// };

// export default AnalyticsLayout;

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Outlet, useSearchParams } from "react-router-dom";
import { Header } from "../../../components/Header/Header";
import { Search } from "lucide-react";
import Cookies from "js-cookie";
import api from "../../chat/api";
import DynamicColumnDropdown from "./DynamicColumnDropdown";


export const ColumnIcon = ({ className }) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="12" y1="3" x2="12" y2="21"></line>
  </svg>
);


const VIEWS_CONFIG = {
  RESPONSE_EVAL: {
    apiView: "response_evaluation",
    storageKey: "analytics_columnPreferences_v1",
    primaryColumn: "timestamp",
    labels: {
      timestamp: "Date & Time",
      context: "Context",
      user_query: "User Query",
      feedback: "Feedback",
      feedback_comment: "Comment",
      member: "User",
      response: "AI Response",
    },
    defaults: [
      { name: "timestamp", visible: true, order: 0 },
      { name: "feedback", visible: true, order: 1 },
      { name: "user_query", visible: true, order: 2 },
      { name: "response", visible: true, order: 3 },
      { name: "context", visible: true, order: 4 },
      { name: "member", visible: true, order: 5 },
      { name: "feedback_comment", visible: true, order: 6 },
    ]
  },
  KNOWLEDGE_GAPS: {
    apiView: "knowledge_gap",
    storageKey: "knowledgeGaps_columnPreferences_v2", 
    primaryColumn: "timestamp", 
    labels: {
      timestamp: "Date & Time",
      user_query: "User Query",
      context: "Context",
      response: "AI Response",
      chat_score: "Chat Score"
    },
    defaults: [
      { name: "timestamp", visible: true, order: 0 },
      { name: "user_query", visible: true, order: 1 },
      { name: "context", visible: true, order: 2 },
      { name: "response", visible: true, order: 3 },
      { name: "chat_score", visible: true, order: 4 },
    ]
  }
};


// CACHE OUTSIDE COMPONENT TO PREVENT REPETITIVE CALLS ON REMOUNT
const fetchedColumnsCache = new Set();


const AnalyticsLayout = ({ isMenuOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();


  const [searchParams, setSearchParams] = useSearchParams();
  // Get owner organization ID directly from cookies
  const orgId = Cookies.get("selected_org_id");


  const [searchQuery, setSearchQuery] = useState("");
  const [isColumnDropdownOpen, setIsColumnDropdownOpen] = useState(false);


  const isKnowledgeGaps = currentPath.includes("knowledge-gaps");
  const searchPlaceholder = isKnowledgeGaps ? "Search queries..." : "Search queries or feedback...";
  const activeConfig = isKnowledgeGaps ? VIEWS_CONFIG.KNOWLEDGE_GAPS : VIEWS_CONFIG.RESPONSE_EVAL;

  // EXTRACT PRIMITIVE VALUE FOR DEPENDENCY ARRAY
  const apiView = activeConfig.apiView;


  const [columnPreferences, setColumnPreferences] = useState([]);
  const [isLoadingColumns, setIsLoadingColumns] = useState(true); 


  // Reset Search Query and Dropdown on Route change
  useEffect(() => {
    setSearchQuery("");
    setIsColumnDropdownOpen(false);
  }, [currentPath]);


  // Automatically enforce the selected_org_id into the URL parameters
  useEffect(() => {
    const currentOrgIdInUrl = searchParams.get("org_id");

    if (orgId && currentOrgIdInUrl !== orgId) {
      setSearchParams((prevParams) => {
        const newParams = new URLSearchParams(prevParams);
        newParams.set("org_id", orgId);
        return newParams;
      }, { replace: true });
    }
  // REMOVED searchParams FROM DEPENDENCIES TO PREVENT INFINITE ROUTER LOOPS
  }, [orgId, setSearchParams]);


  useEffect(() => {
    const fetchColumns = async () => {
      setIsLoadingColumns(true);
      try {
        const saved = localStorage.getItem(activeConfig.storageKey);
        if (saved) setColumnPreferences(JSON.parse(saved));
        else setColumnPreferences(activeConfig.defaults);

        // CHECK CACHE BEFORE MAKING API CALL
        if (fetchedColumnsCache.has(apiView)) {
          setIsLoadingColumns(false);
          return;
        }


        const token = Cookies.get("access_token");
        if (!token) return;


        const response = await api.get(`/api/v1/rfp/column-preferences/?view=${apiView}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (response.data && response.data.columns) {
          setColumnPreferences(response.data.columns);
          localStorage.setItem(activeConfig.storageKey, JSON.stringify(response.data.columns));
          
          // MARK AS FETCHED
          fetchedColumnsCache.add(apiView);
        }
      } catch (error) {
        console.error(`Failed to fetch column preferences for ${apiView}:`, error);
      } finally {
        setIsLoadingColumns(false); 
      }
    };
    fetchColumns();
  // USE PRIMITIVE STRING AS DEPENDENCY INSTEAD OF OBJECT/ARRAY
  }, [apiView]);


  const saveColumnPreferences = async (updatedColumns) => {
    try {
      const payload = {
        view: activeConfig.apiView,
        columns: updatedColumns.map((col, index) => ({
          name: col.name,
          visible: col.visible === true || col.visible === "true",
          order: index,
        })),
      };
      setColumnPreferences(payload.columns);
      localStorage.setItem(activeConfig.storageKey, JSON.stringify(payload.columns));
      const token = Cookies.get("access_token");
      
      // ADDED ?view= QUERY PARAMETER TO PATCH REQUEST
      await api.patch(`/api/v1/rfp/column-preferences/?view=${apiView}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.error("Failed to save column preferences:", error);
    }
  };


  const tabs = [
    { name: "Response Evaluation", path: "response-evaluation" },
    { name: "Knowledge Gaps", path: "knowledge-gaps" },
  ];


  return (
    <div className="flex flex-col h-full w-full font-outfit overflow-hidden bg-[#FAFAFA] relative">
      <div className="flex-shrink-0 bg-white">
        <Header name="Analytics" icon={""} isMenuOpen={isMenuOpen} />
      </div>


      <div className="flex justify-between items-center px-6 pt-2 pb-0 bg-white flex-shrink-0 w-full">
        <div className="flex items-center gap-4 border-b-[1px]">
          {tabs.map((tab) => {
            const isActive = currentPath.includes(tab.path.toLowerCase()) || (currentPath.endsWith('/analytics') && tab.path === 'response-evaluation');
            return (
              <button
                key={tab.name}
                onClick={() => navigate(`${tab.path}?${searchParams.toString()}`)}
                className={`font-outfit text-[15px] pb-0 px-1 transition-colors ${
                  isActive ? "text-[#BB42AE] font-semibold border-b-[2px] border-[#BB42AE]" : "text-[#707070] font-medium border-transparent hover:text-[#C95EBE]"
                }`}
              >
                {tab.name}
              </button>
            );
          })}
        </div>


        <div className="flex items-center gap-3 pb-3">
          <div id="analytics-filter-portal" className="empty:hidden"></div>
          <div className="relative inline-flex items-center gap-2">
            <button
              onClick={() => setIsColumnDropdownOpen((p) => !p)}
              disabled={isLoadingColumns}
              className={`flex items-center gap-2 px-3 py-1.5 border rounded text-[14px] font-outfit transition-colors ${
                isLoadingColumns ? "opacity-50 cursor-not-allowed border-[#00000036] text-[#52525B]" :
                isColumnDropdownOpen ? "border-[#BB42AE] text-[#BB42AE] bg-[#F8F3FF]" : "border-[#00000036] text-[#52525B] hover:bg-gray-50"
              }`}
            >
              {isLoadingColumns ? (
                <div className="w-3.5 h-3.5 border-2 border-[#52525B] border-t-transparent rounded-full animate-spin"></div>
              ) : (
                <ColumnIcon />
              )}
              Columns
            </button>
            {isColumnDropdownOpen && !isLoadingColumns && (
              <>
                <div className="fixed inset-0 z-[998] bg-transparent" onClick={() => setIsColumnDropdownOpen(false)} />
                <DynamicColumnDropdown
                  columns={columnPreferences}
                  setColumns={setColumnPreferences}
                  onSave={saveColumnPreferences}
                  onClose={() => setIsColumnDropdownOpen(false)}
                  primaryColumn={activeConfig.primaryColumn}
                  columnLabels={activeConfig.labels}
                  defaultColumns={activeConfig.defaults}
                  storageKey={activeConfig.storageKey}
                />
              </>
            )}
          </div>
          <div className="relative w-[250px]">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600" size={18} />
            <input
              type="text"
              placeholder={searchPlaceholder}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 border rounded-md box-border h-[35px] text-[14px]"
            />
          </div>
        </div>
      </div>


      <div className="flex-1 flex flex-col overflow-hidden bg-[#fafafa]">
        <Outlet context={{ searchQuery, orgId, columnPreferences, isLoadingColumns }} />
      </div>


      <div id="analytics-footer-portal" className="w-full bg-white border-t border-black/10 flex-shrink-0 z-10 empty:hidden"></div>
    </div>
  );
};


export default AnalyticsLayout;